import React, {useCallback, useEffect, useState} from 'react';
import {FullHeightCard} from "../../components/cards";
import {
    CreateReportModal,
    emptyReportAttributes,
    extractedReportAttributes,
    mapApiTemplateModelToCreateModel
} from "./CreateReportModal";
import {useHistory, useLocation} from "react-router-dom";
import {ReportsTable} from "./ReportsTable";
import RepApi from "../../services/RepApi";
import {repApiAdaptedPageData} from "../../utils";
import {Button} from 'antd';
import {ReloadOutlined} from '@ant-design/icons';


export function Reports() {
    const [creatingModalVisible, setCreatingModalVisible] = useState(false);
    const [refreshToken, setRefreshToken] = useState(0);
    const history = useHistory();
    const [reportsSource] = useState({
        values: (page, limit) => {
            return new Promise((resolve, reject) => {
               RepApi.get('/reports', {params: {page, limit}}).then(({data}) => {
                   resolve(repApiAdaptedPageData(data));
               }).catch(reject);
            });
        }
    });

    const handleRefreshClick = useCallback(() => {
        setRefreshToken(token => token + 1);
    }, []);

    const goToReportPage = id => {
        history.push(`/reports/${id}`);
    }

    const handleNewReportClick = () => {
        setCreatingModalVisible(true);
    }

    return (
        <>
            <FullHeightCard
                title="Reports"
                extra={
                    <div style={{display: 'flex', gap: 8}}>
                        <Button icon={<ReloadOutlined />} onClick={handleRefreshClick}>
                            Refresh
                        </Button>
                        <Button onClick={handleNewReportClick} type="primary">
                            Create new Report
                        </Button>
                    </div>
                }
            >
                <ReportsTable
                    asyncDataSource={reportsSource}
                    refreshToken={refreshToken}
                    onViewClick={goToReportPage}
                />
            </FullHeightCard>
            <CreateReportModal
                attributes={emptyReportAttributes}
                visible={creatingModalVisible}
                updateVisibility={setCreatingModalVisible}
                onCreate={data => goToReportPage(data.id)}
            />
            <CreateReportModalFromUrl onCreate={data => goToReportPage(data.id)}/>
        </>
    );
}


function CreateReportModalFromUrl({onCreate}) {
    const [modalVisible, setModalVisible] = useState(false);
    const [attributes, setAttributes] = useState(new Promise((resolve) => resolve()));
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const id = searchParams.get("from-template");
        let parameters;
        try {
            parameters = JSON.parse(searchParams.get("with-parameters") ?? "{}");
        } catch (e) {
            parameters = {};
        }
        if (id != null) {
            setAttributes(new Promise((resolve, reject) => {
                RepApi.get(
                    `/templates/${id}`
                ).then(response => {
                    resolve(extractedReportAttributes.extract({
                        template: mapApiTemplateModelToCreateModel({
                            ...response.data,
                            parameters
                        })
                    }));
                }).catch(reject)
            }));
            setModalVisible(true);
        }
    }, [location]);

    return (
        <CreateReportModal
            attributes={attributes}
            visible={modalVisible}
            updateVisibility={setModalVisible}
            onCreate={onCreate}
        />
    );
}
